export const cloneItem = {
  data () {
    return {
      items: []
    }
  },
  methods: {
    clone (item) {
      let newItem = {...item}
      newItem.id = this.items.length + 1
      newItem.new = true
      newItem.clonedFrom = item.id
      if (typeof item.order !== 'undefined') {
        newItem.order = parseInt(this.items[this.items.length - 1].order) + 1
      }
      // Child items should not have id's
      newItem = this.cleanupRelations(newItem)
      this.items.push(newItem)
    },
    cleanupRelations (item) {
      if (item.hasOwnProperty('rollingStockCoupes')) {
        item['rollingStockCoupes'].forEach((entry) => {
          entry.new = true
          entry.clonedFrom = entry.id
        })
      }
      return item
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/cloneItem.js